import React, { FC } from 'react';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';
import fields, { socialMediaBarFields } from '../../../../constants/fields.const';
import { iconSize } from '../../../../constants/icon.constants';
import { FieldEditFrameComponent } from '../../editFrame';
import Icon from '../../icon';
import { TEELink } from '../types/socialMediaBar.types';

const EELink: FC<TEELink> = (props) => {
  const { item } = props;
  const {sitecoreContext} = useSitecoreContext();
  return (
    <>
      <FieldEditFrameComponent
        itemId={item?.id}
        fields={[fields.icon, socialMediaBarFields.socialMedia, socialMediaBarFields.postText]}
        sitecoreContext={sitecoreContext}
      >
        <Icon iconField={item?.fields?.icon} size={iconSize.mbl} extraClassName={'social-media-bar__social-icon-EE'} />
      </FieldEditFrameComponent>
    </>
  );
};

export default EELink;
